import { PasswordManager } from 'features/navigation/Header/modals/components/password-manager';
import { memo } from 'react';
import { useTranslation } from 'react-i18next';
import { Modal, ModalBody } from 'reactstrap';

type ChangePasswordModalProps = {
    isOpen: boolean;
    onClose: () => void;

}

const ChangePasswordModal = memo(({ isOpen, onClose, }: ChangePasswordModalProps) => {

    const { t } = useTranslation();

    return (
        <>
            <Modal fade={false} isOpen={isOpen} size="md" centered={true}>
                <ModalBody className='p-5'>
                    <div className='d-flex align-items-center justify-content-center flex-column gap-3'>

                        <svg xmlns="http://www.w3.org/2000/svg" width="56" height="56" viewBox="0 0 56 56" fill="none">
                            <path d="M9.84375 15.6538L28 8.60126L46.1562 15.645C46.3925 19.635 45.7625 25.865 43.12 31.9463C40.4775 38.0275 35.8225 43.96 28 47.3463C20.1775 43.96 15.5225 38.0363 12.88 31.955C10.2375 25.8738 9.6075 19.6438 9.84375 15.6538ZM48.9562 15.4875L48.8512 13.6938L47.1712 13.0375L29.015 5.99376L28 5.60001L26.985 5.99376L8.82875 13.0375L7.1575 13.6938L7.0525 15.4875C6.79875 19.8538 7.48125 26.5388 10.3162 33.0663C13.1775 39.655 18.2787 46.1913 26.8887 49.9188L28 50.4L29.1112 49.9188C37.7212 46.1913 42.8225 39.655 45.6837 33.0663C48.5187 26.53 49.2012 19.8538 48.9475 15.4875H48.9562ZM28 21.7C28.5569 21.7 29.0911 21.9213 29.4849 22.3151C29.8787 22.7089 30.1 23.2431 30.1 23.8C30.1 24.357 29.8787 24.8911 29.4849 25.2849C29.0911 25.6788 28.5569 25.9 28 25.9C27.443 25.9 26.9089 25.6788 26.5151 25.2849C26.1212 24.8911 25.9 24.357 25.9 23.8C25.9 23.2431 26.1212 22.7089 26.5151 22.3151C26.9089 21.9213 27.443 21.7 28 21.7ZM32.9 23.8C32.9 21.0963 30.7037 18.9 28 18.9C25.2962 18.9 23.1 21.0963 23.1 23.8C23.1 26.0225 24.5787 27.895 26.6 28.4988V35V36.4H29.4V35V28.4988C31.4212 27.895 32.9 26.0225 32.9 23.8Z" fill="#262626" />
                        </svg>
                        <h5>{t("CHANGE_YOUR_PASSWORD")}</h5>
                        <span className='text-label text-center mb-4'>{t('CHANGE_PASSWORD_DESCRIPTION')}</span>
                    </div>
                    <div className='p-3'>
                        <PasswordManager onClose={onClose} showTitle={false} />
                    </div>
                </ModalBody>
            </Modal>
        </>
    )
})

ChangePasswordModal.displayName = 'ChangePasswordModal';
export { ChangePasswordModal };

